// Redux
import { connect } from "react-redux";
// Router
import { withRouter } from "react-router-dom";
// Action
import { openMenu, closeMenu } from "redux/modules/header";
// Component
import Header from "components/Header";
// Utils
import history from "utils/history";
import storage from "utils/storage";
import { isAdmin, isCustomerAdmin } from "utils/formatter";
// CustomerList
import { breakCustomerList } from "redux/modules/customerList";
// AdminList
import { breakAdminList } from "redux/modules/adminList";

const mapStateToProps = state => ({ ...state.header });

const mapDispatchToProps = (dispatch, ownProps) => ({
  historyPush: path => history.push(path, ownProps),
  openMenu: event => dispatch(openMenu(event)),
  closeMenu: () => dispatch(closeMenu()),
  handleLogout: () => {
    storage.removeToken();
    dispatch(closeMenu());
    dispatch(breakCustomerList());
    dispatch(breakAdminList());
    history.push(isCustomerAdmin() ? "/" : "/login", ownProps);
  },
  handleGoHome: () => {
    if (isAdmin()) {
      history.push("/customer_list", ownProps);
    } else if (isCustomerAdmin()) {
      history.push("/survey_list", ownProps);
    }
  }
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));



// WEBPACK FOOTER //
// ./src/containers/HeaderContainer.js